import type { RowItem } from '@commons/bo-ui/table/table.model';
import type { BehaviorSubject } from 'rxjs';

import { Directive, HostListener, inject, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appBoCellTemplateId]',
  standalone: true,
})
export class BoCellTemplateRefDirective {
  @Input('appBoCellTemplateId') id!: string;

  templateRef = inject(TemplateRef<any>);
}

@Directive({
  selector: '[appBoExpandableRowTemplate]',
  standalone: true,
})
export class BoExpandableRowTemplateRefDirective {
  templateRef = inject(TemplateRef<any>);
}

@Directive({
  selector: '[appBoClickToExpandRow]',
  standalone: true,
})
export class BoClickToExpandRowDirective {
  @Input('appBoClickToExpandRow') rowExpander$!: BehaviorSubject<RowItem | null>;
  @Input() rowToExpand!: RowItem;

  @HostListener('click') onClick(): void {
    this.rowExpander$.next(this.rowExpander$.value === this.rowToExpand ? null : this.rowToExpand);
  }
}
